import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=5897ee48&"
import script from "./Cases.js?vue&type=script&lang=js&"
export * from "./Cases.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports